import React from "react";
import LegalShell from "./LegalShell";

export default function Confidentialite() {
  return (
    <LegalShell
      title="Politique de confidentialité &amp; RGPD"
      subtitle="Comment DepannRoute collecte, utilise et protège vos données personnelles conformément au Règlement Général sur la Protection des Données (UE 2016/679)."
      lastUpdate="19 février 2026"
      canonical="https://depannroute.com/confidentialite"
    >
      <h2>1. Responsable du traitement</h2>
      <p>
        Le responsable du traitement des données personnelles collectées sur le Site est
        DepannRoute (voir <a href="/mentions-legales">Mentions légales</a>).
      </p>
      <p>
        Délégué à la Protection des Données (DPO) : <a href="mailto:dpo@depannroute.com">dpo@depannroute.com</a>
      </p>

      <h2>2. Données collectées</h2>
      <p>Nous collectons uniquement les données strictement nécessaires aux finalités suivantes :</p>
      <ul>
        <li><strong>Identification :</strong> nom, prénom, email, mot de passe chiffré (bcrypt), téléphone.</li>
        <li><strong>Informations professionnelles (Dépanneurs) :</strong> raison sociale, SIRET, attestation d'assurance.</li>
        <li><strong>Données de mission :</strong> trajets, véhicules, dates, urgence, description.</li>
        <li><strong>Données de paiement :</strong> traitées par <strong>Stripe</strong> (aucune donnée bancaire n'est stockée par DepannRoute).</li>
        <li><strong>Données techniques :</strong> adresse IP, user-agent, logs de connexion (conservation 12 mois).</li>
      </ul>

      <h2>3. Finalités &amp; bases légales</h2>
      <ul>
        <li><strong>Fourniture du service</strong> — exécution du contrat (art. 6.1.b RGPD).</li>
        <li><strong>Facturation &amp; comptabilité</strong> — obligation légale (art. 6.1.c).</li>
        <li><strong>Lutte contre la fraude</strong> — intérêt légitime (art. 6.1.f).</li>
        <li><strong>Communication marketing</strong> — consentement (art. 6.1.a), révocable à tout moment.</li>
        <li><strong>Amélioration de l'algorithme de matching</strong> — intérêt légitime, données anonymisées.</li>
      </ul>

      <h2>4. Durée de conservation</h2>
      <ul>
        <li>Données de compte : pendant toute la durée de la relation + 3 ans après la dernière activité.</li>
        <li>Factures : 10 ans (obligation comptable).</li>
        <li>Logs de connexion : 12 mois.</li>
        <li>Cookies : voir <a href="/cookies">Politique cookies</a>.</li>
      </ul>

      <h2>5. Destinataires</h2>
      <p>
        Vos données sont accessibles uniquement aux personnes habilitées chez DepannRoute et à nos
        sous-traitants strictement nécessaires :
      </p>
      <ul>
        <li><strong>Stripe</strong> (paiement) — hébergement UE/US, certifié PCI-DSS.</li>
        <li><strong>[À REMPLIR — hébergeur]</strong> (hébergement applicatif).</li>
        <li><strong>Fournisseur d'emails transactionnels</strong> (confirmations, réinitialisation mot de passe).</li>
      </ul>
      <p>
        Aucune donnée n'est vendue ou cédée à des tiers à des fins commerciales.
      </p>

      <h2>6. Transfert hors UE</h2>
      <p>
        Lorsque des transferts vers un pays hors Union européenne sont nécessaires (ex : sous-traitant),
        ils sont encadrés par les Clauses Contractuelles Types approuvées par la Commission européenne.
      </p>

      <h2>7. Vos droits</h2>
      <p>Conformément au RGPD, vous disposez des droits suivants :</p>
      <ul>
        <li><strong>Accès</strong> à vos données personnelles.</li>
        <li><strong>Rectification</strong> des données inexactes.</li>
        <li><strong>Effacement</strong> (« droit à l'oubli »).</li>
        <li><strong>Limitation</strong> du traitement.</li>
        <li><strong>Portabilité</strong> de vos données dans un format structuré (JSON).</li>
        <li><strong>Opposition</strong> au traitement fondé sur un intérêt légitime.</li>
        <li><strong>Retrait du consentement</strong> à tout moment.</li>
      </ul>
      <p>
        Pour exercer ces droits : <a href="mailto:dpo@depannroute.com">dpo@depannroute.com</a>, avec
        une copie d'une pièce d'identité. Réponse sous un délai maximum d'un mois.
      </p>

      <h2>8. Réclamation auprès de la CNIL</h2>
      <p>
        Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation
        auprès de la <strong>Commission Nationale de l'Informatique et des Libertés (CNIL)</strong> :
        {" "}<a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>.
      </p>

      <h2>9. Sécurité</h2>
      <p>
        Nous mettons en œuvre des mesures techniques et organisationnelles appropriées :
        chiffrement TLS de bout en bout, mots de passe hachés (bcrypt), cookies d'authentification
        httpOnly + Secure + SameSite, journalisation des accès et revue régulière des droits.
      </p>
    </LegalShell>
  );
}
